import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col, Table, Spinner } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { objectShowNumber } from '@app/utils/define';
import { useHistory } from 'react-router-dom';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { createUrlWithParam } from '@app/utils/helper';


import {
  nhiemVuCaNhanDebugCurrentUserAction,
  nhiemVuCaNhanGetProjectTasksAction,
  nhiemVuCaNhanGetOtherTasksAction,
  nhiemVuCaNhanGetYeuCauTasksAction,
  nhiemVuCaNhanGetHoTroTasksAction,
} from '@app/store/reducers/nhiemvucanhan';

import {
  TRANG_THAI_CONG_VIEC_OPTIONS,
  TRANG_THAI_KHAC_OPTIONS,
  TRANG_THAI_YEU_CAU_OPTIONS,
  TRANG_THAI_HO_TRO_OPTIONS,

  MUC_DO_UU_TIEN,
  MUC_DO_PHUC_TAP_OPTIONS,
  LOAI_LOI_OPTIONS,

  mapMucDoUuTienLabel,
  mapTrangThaiCongViecLabel,
  mapTrangThaiKhacLabel,
  mapTrangThaiYeuCauLabel,
  mapTrangThaiHoTroLabel,
  mapMucDoPhucTapLabel,
  mapLoaiLoiLabel,
} from '@app/store/constants';

import { linhVucGetAllAction } from '@store/reducers/linhvuc';
import { khoaGetAllAction } from '@store/reducers/khoa';
import { nguoiPhoiHopGetAllAction } from '@store/reducers/nguoiphoihop';

const COLUMN_STYLE_MAP = {
  canlam: { headerBg: '#e1e5f2', headerText: '#333333', border: '#c4ccdd', bodyBg: '#f7f9fc' },
  danglam: { headerBg: '#d3e5ff', headerText: '#245b8f', border: '#aac6ff', bodyBg: '#f3f7ff' },
  choduyet: { headerBg: '#ffe0b2', headerText: '#8f6a24', border: '#ffc875', bodyBg: '#fff5e0' },
  hoanthanh: { headerBg: '#cef4e4', headerText: '#247a55', border: '#a0e0c6', bodyBg: '#f1fbf6' },
};

const getStatusStyleProject = (status) => {
  const opt = TRANG_THAI_CONG_VIEC_OPTIONS.find((x) => x.value === status || x.key === status);
  const key = opt ? opt.key : null;
  const style = key ? COLUMN_STYLE_MAP[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.headerBg,
    border: `1px solid ${style.border}`,
    color: style.headerText,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

const toCongViecStatusKey = (status) => {
  const opt = TRANG_THAI_CONG_VIEC_OPTIONS.find((x) => x.value === status || x.key === status);
  return opt ? opt.key : null;
};

const getEffectiveTienDoProjectTask = (item) => {
  const key = toCongViecStatusKey(item?.status);
  if (key === 'hoanthanh') return 100;
  return item?.tienDo ?? null;
};

const STATUS_COLOR_MAP_KHAC = {
  chuabatdau: { bg: '#e1e5f2', text: '#333333', border: '#c4ccdd' },
  dangthuchien: { bg: '#d3e5ff', text: '#245b8f', border: '#aac6ff' },
  hoanthanh: { bg: '#cef4e4', text: '#247a55', border: '#a0e0c6' },
};

const toTrangThaiKhacKey = (valueOrKey) => {
  const opt =
    TRANG_THAI_KHAC_OPTIONS.find((o) => o.value === valueOrKey || o.key === valueOrKey) ||
    TRANG_THAI_KHAC_OPTIONS.find((o) => o.value === Number(valueOrKey));
  return opt ? opt.key : null;
};

const getStatusStyleNhiemVuKhac = (status) => {
  const key = toTrangThaiKhacKey(status);
  const style = key ? STATUS_COLOR_MAP_KHAC[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.bg,
    border: `1px solid ${style.border}`,
    color: style.text,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

// Yêu cầu: 0..3
const STATUS_COLOR_MAP_YEUCAU = {
  chophanhoi: { bg: '#e1e5f2', text: '#333333', border: '#c4ccdd' },
  dangtest: { bg: '#d3e5ff', text: '#245b8f', border: '#aac6ff' },
  chonangcap: { bg: '#ffe0b2', text: '#8f6a24', border: '#ffc875' },
  hoanthanh: { bg: '#cef4e4', text: '#247a55', border: '#a0e0c6' },
};

const toTrangThaiYeuCauKey = (valueOrKey) => {
  const opt =
    TRANG_THAI_YEU_CAU_OPTIONS.find((o) => o.value === valueOrKey || o.key === valueOrKey) ||
    TRANG_THAI_YEU_CAU_OPTIONS.find((o) => o.value === Number(valueOrKey));
  return opt ? opt.key : null;
};

const getStatusStyleYeuCau = (status) => {
  const key = toTrangThaiYeuCauKey(status);
  const style = key ? STATUS_COLOR_MAP_YEUCAU[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.bg,
    border: `1px solid ${style.border}`,
    color: style.text,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

// HoTro: 0..1
const STATUS_COLOR_MAP_HOTRO = {
  dangthuchien: { bg: '#d3e5ff', text: '#245b8f', border: '#aac6ff' },
  hoanthanh: { bg: '#cef4e4', text: '#247a55', border: '#a0e0c6' },
};

const toTrangThaiHoTroKey = (valueOrKey) => {
  const opt =
    TRANG_THAI_HO_TRO_OPTIONS.find((o) => o.value === valueOrKey || o.key === valueOrKey) ||
    TRANG_THAI_HO_TRO_OPTIONS.find((o) => o.value === Number(valueOrKey));
  return opt ? opt.key : null;
};

const getStatusStyleHoTro = (status) => {
  const key = toTrangThaiHoTroKey(status);
  const style = key ? STATUS_COLOR_MAP_HOTRO[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.bg,
    border: `1px solid ${style.border}`,
    color: style.text,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

const TABLE_HEADER_FOOTER_CELL_STYLE = {
  textAlign: 'center',
  verticalAlign: 'middle',
};

const safeText = (v) => (v == null ? '' : String(v));

const formatDate = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString();
};

const getTicketDisplay = (url) => {
  if (!url) return '';
  // Bắt đúng dạng GitHub issue
  const match = url.match(/github\.com\/.+\/issues\/(\d+)/);
  // Nếu đúng → trả về số ticket
  if (match) return match[1];
  // Nếu không đúng → hiển thị full link
    return 'Link';
};

const renderTicketLink = (url) => {
  if (!url) return '';
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" title={url}>
      {getTicketDisplay(url)}
    </a>
  );
};

const pickName = (obj) =>
  obj?.name ||
  obj?.ten ||
  obj?.tenKhoa ||
  obj?.tenLinhVuc ||
  obj?.title ||
  obj?.label ||
  '';

const NhiemVuCaNhan = () => {
  const dispatch = useDispatch();
  const history = useHistory();


  const {
    loadingUser,
    loadingProjectTasks,
    loadingOtherTasks,
    loadingYeuCauTasks,
    loadingHoTroTasks,

    errorUser,
    errorProjectTasks,
    errorOtherTasks,
    errorYeuCauTasks,
    errorHoTroTasks,

    currentUser,
    projectTasks,
    otherTasks,
    yeuCauTasks,
    hoTroTasks,
  } = useSelector((state) => state.nhiemVuCaNhan);

  // lấy list khoa/linhvuc để map tên
  const khoaState = useSelector((state) => state.khoa || {});
  const linhVucState = useSelector((state) => state.linhvuc || {});
  const nguoiPhoiHopState = useSelector((state) => state.nguoiPhoiHop || {});

  const khoaList = Array.isArray(khoaState.listKhoa) ? khoaState.listKhoa : [];
  const linhVucList = Array.isArray(linhVucState.listLinhVuc) ? linhVucState.listLinhVuc : [];
  const nguoiPhoiHopList = Array.isArray(nguoiPhoiHopState.listNguoiPhoiHop)
    ? nguoiPhoiHopState.listNguoiPhoiHop
    : [];

  const loading =
    loadingUser || loadingProjectTasks || loadingOtherTasks || loadingYeuCauTasks || loadingHoTroTasks;

  const [filterTab, setFilterTab] = useState(() => sessionStorage.getItem('nvcn_filterTab') || 'all');

  // filters DEV
  const [projectStatusFilter, setProjectStatusFilter] = useState(() => sessionStorage.getItem('nvcn_projectStatusFilter') || '');
  const [projectPriorityFilter, setProjectPriorityFilter] = useState(() => sessionStorage.getItem('nvcn_projectPriorityFilter') || '');

  // filters OTHER
  const [otherStatusFilter, setOtherStatusFilter] = useState(() => sessionStorage.getItem('nvcn_otherStatusFilter') || '');
  const [otherPriorityFilter, setOtherPriorityFilter] = useState(() => sessionStorage.getItem('nvcn_otherPriorityFilter') || '');

  // filters YEUCAU
  const [yeuCauStatusFilter, setYeuCauStatusFilter] = useState(() => sessionStorage.getItem('nvcn_yeuCauStatusFilter') || '');
  const [yeuCauPriorityFilter, setYeuCauPriorityFilter] = useState(() => sessionStorage.getItem('nvcn_yeuCauPriorityFilter') || '');

  // filters HOTRO
  const [hoTroStatusFilter, setHoTroStatusFilter] = useState(() => sessionStorage.getItem('nvcn_hoTroStatusFilter') || '');
  const [hoTroLoaiLoiFilter, setHoTroLoaiLoiFilter] = useState(() => sessionStorage.getItem('nvcn_hoTroLoaiLoiFilter') || '');
  const [hoTroMucDoFilter, setHoTroMucDoFilter] = useState(() => sessionStorage.getItem('nvcn_hoTroMucDoFilter') || '');

  // paging
  const [pageProject, setPageProject] = useState(() => Number(sessionStorage.getItem('nvcn_pageProject')) || 1);
  const [pageSizeProject, setPageSizeProject] = useState(() => Number(sessionStorage.getItem('nvcn_pageSizeProject')) || 20);

  const [pageOther, setPageOther] = useState(() => Number(sessionStorage.getItem('nvcn_pageOther')) || 1);
  const [pageSizeOther, setPageSizeOther] = useState(() => Number(sessionStorage.getItem('nvcn_pageSizeOther')) || 20);

  const [pageYeuCau, setPageYeuCau] = useState(() => Number(sessionStorage.getItem('nvcn_pageYeuCau')) || 1);
  const [pageSizeYeuCau, setPageSizeYeuCau] = useState(() => Number(sessionStorage.getItem('nvcn_pageSizeYeuCau')) || 20);

  const [pageHoTro, setPageHoTro] = useState(() => Number(sessionStorage.getItem('nvcn_pageHoTro')) || 1);
  const [pageSizeHoTro, setPageSizeHoTro] = useState(() => Number(sessionStorage.getItem('nvcn_pageSizeHoTro')) || 20);

  useEffect(() => {
    sessionStorage.setItem('nvcn_filterTab', filterTab);
    sessionStorage.setItem('nvcn_projectStatusFilter', projectStatusFilter);
    sessionStorage.setItem('nvcn_projectPriorityFilter', projectPriorityFilter);
    sessionStorage.setItem('nvcn_otherStatusFilter', otherStatusFilter);
    sessionStorage.setItem('nvcn_otherPriorityFilter', otherPriorityFilter);
    sessionStorage.setItem('nvcn_yeuCauStatusFilter', yeuCauStatusFilter);
    sessionStorage.setItem('nvcn_yeuCauPriorityFilter', yeuCauPriorityFilter);
    sessionStorage.setItem('nvcn_hoTroStatusFilter', hoTroStatusFilter);
    sessionStorage.setItem('nvcn_hoTroLoaiLoiFilter', hoTroLoaiLoiFilter);
    sessionStorage.setItem('nvcn_hoTroMucDoFilter', hoTroMucDoFilter);
    sessionStorage.setItem('nvcn_pageProject', pageProject);
    sessionStorage.setItem('nvcn_pageSizeProject', pageSizeProject);
    sessionStorage.setItem('nvcn_pageOther', pageOther);
    sessionStorage.setItem('nvcn_pageSizeOther', pageSizeOther);
    sessionStorage.setItem('nvcn_pageYeuCau', pageYeuCau);
    sessionStorage.setItem('nvcn_pageSizeYeuCau', pageSizeYeuCau);
    sessionStorage.setItem('nvcn_pageHoTro', pageHoTro);
    sessionStorage.setItem('nvcn_pageSizeHoTro', pageSizeHoTro);
  }, [
    filterTab, projectStatusFilter, projectPriorityFilter, otherStatusFilter, otherPriorityFilter,
    yeuCauStatusFilter, yeuCauPriorityFilter, hoTroStatusFilter, hoTroLoaiLoiFilter, hoTroMucDoFilter,
    pageProject, pageSizeProject, pageOther, pageSizeOther, pageYeuCau, pageSizeYeuCau, pageHoTro, pageSizeHoTro
  ]);

  useEffect(() => {
    dispatch(nhiemVuCaNhanDebugCurrentUserAction());
    // load danh mục để map tên
    dispatch(linhVucGetAllAction());
    dispatch(khoaGetAllAction());
    dispatch(nguoiPhoiHopGetAllAction());
  }, [dispatch]);

  // load dev
  useEffect(() => {
    const params = {};
    if (projectStatusFilter !== '') params.status = Number(projectStatusFilter);
    if (projectPriorityFilter !== '') params.priority = Number(projectPriorityFilter);
    dispatch(nhiemVuCaNhanGetProjectTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, projectStatusFilter, projectPriorityFilter]);

  // load other
  useEffect(() => {
    const params = {};
    if (otherStatusFilter !== '') params.status = Number(otherStatusFilter);
    if (otherPriorityFilter !== '') params.priority = Number(otherPriorityFilter);
    dispatch(nhiemVuCaNhanGetOtherTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, otherStatusFilter, otherPriorityFilter]);

  // load yeucau
  useEffect(() => {
    const params = {};
    if (yeuCauStatusFilter !== '') params.status = Number(yeuCauStatusFilter);
    if (yeuCauPriorityFilter !== '') params.priority = Number(yeuCauPriorityFilter);
    dispatch(nhiemVuCaNhanGetYeuCauTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, yeuCauStatusFilter, yeuCauPriorityFilter]);

  // load hotro
  useEffect(() => {
    const params = {};
    if (hoTroStatusFilter !== '') params.status = Number(hoTroStatusFilter);
    if (hoTroLoaiLoiFilter !== '') params.loaiLoi = Number(hoTroLoaiLoiFilter);
    if (hoTroMucDoFilter !== '') params.mucDoPhucTap = Number(hoTroMucDoFilter);
    dispatch(nhiemVuCaNhanGetHoTroTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, hoTroStatusFilter, hoTroLoaiLoiFilter, hoTroMucDoFilter]);

  const getLinhVucNameById = (id) => {
    if (id == null) return '';
    if (!Array.isArray(linhVucList) || linhVucList.length === 0) return '';

    const found = linhVucList.find((x) => x?.id === id);
    return pickName(found) || '';
    };

    const getKhoaCodesByIds = (ids) => {
        if (!Array.isArray(ids) || ids.length === 0) return '';
        if (!Array.isArray(khoaList) || khoaList.length === 0) return '';

        const codes = ids
            .map((kid) => khoaList.find((k) => k?.id === kid)?.maKhoa)
            .filter(Boolean);

        return codes.join(', ');
    };

    const getNguoiPhoiHopNamesByIds = (ids) => {
        if (!Array.isArray(ids) || ids.length === 0) return '';
        if (!Array.isArray(nguoiPhoiHopList) || nguoiPhoiHopList.length === 0) return '';

        return ids
            .map((pid) => nguoiPhoiHopList.find((p) => p?.id === pid)?.name)
            .filter(Boolean)
            .join(', ');
        };

  const sortedProjectTasks = useMemo(() => {
    if (!projectTasks) return [];
    return [...projectTasks].sort((a, b) => {
      const idA = a.assignmentId || a.congViecId || a.id || 0;
      const idB = b.assignmentId || b.congViecId || b.id || 0;
      return idB - idA; // mới nhất lên trước
    });
  }, [projectTasks]);

  const sortedOtherTasks = useMemo(() => {
    if (!otherTasks) return [];
    return [...otherTasks].sort((a, b) => {
      const idA = a.nhiemVuId || a.id || 0;
      const idB = b.nhiemVuId || b.id || 0;
      return idB - idA; // mới nhất lên trước
    });
  }, [otherTasks]);

  const sortedYeuCauTasks = useMemo(() => {
    if (!yeuCauTasks) return [];
    return [...yeuCauTasks].sort((a, b) => {
      const idA = a.id || 0;
      const idB = b.id || 0;
      return idB - idA; // mới nhất lên trước
    });
  }, [yeuCauTasks]);

  const sortedHoTroTasks = useMemo(() => {
    if (!hoTroTasks) return [];
    return [...hoTroTasks].sort((a, b) => {
      const da = a.ngayHoTro ? new Date(a.ngayHoTro) : null;
      const db = b.ngayHoTro ? new Date(b.ngayHoTro) : null;
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return db - da; // mới nhất lên trước
    });
  }, [hoTroTasks]);

  // paging data
  const pagedProjectTasks = sortedProjectTasks.slice((pageProject - 1) * pageSizeProject, pageProject * pageSizeProject);
  const pagedOtherTasks = sortedOtherTasks.slice((pageOther - 1) * pageSizeOther, pageOther * pageSizeOther);
  const pagedYeuCauTasks = sortedYeuCauTasks.slice((pageYeuCau - 1) * pageSizeYeuCau, pageYeuCau * pageSizeYeuCau);
  const pagedHoTroTasks = sortedHoTroTasks.slice((pageHoTro - 1) * pageSizeHoTro, pageHoTro * pageSizeHoTro);

  const totalProjectTasks = sortedProjectTasks.length;
  const totalOtherTasks = sortedOtherTasks.length;
  const totalYeuCauTasks = sortedYeuCauTasks.length;
    const totalHoTroTasks = sortedHoTroTasks.length;

    

  return (
    <div className="container-fluid">
      <div className="row mb-2">
        <div className="col-sm-6">
          <h3 className="card-title mb-0">Nhiệm vụ cá nhân</h3>
        </div>
        <div className="col-sm-6 text-right">
          {currentUser && (
            <span className="text-muted">
              Đang hiển thị nhiệm vụ của <strong>{currentUser.fullName || currentUser.username}</strong>
              {currentUser.email ? ` (${currentUser.email})` : ''}
            </span>
          )}
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-12 d-flex justify-content-start">
          <div className="btn-group btn-group-sm">
            <button
              type="button"
              className={`btn ${filterTab === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('all')}
            >
              Tất cả
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'dev' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('dev')}
            >
              Phát triển phần mềm
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'other' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('other')}
            >
              Nhiệm vụ khác
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'yeucau' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('yeucau')}
            >
              Xử lý yêu cầu
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'hotro' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('hotro')}
            >
              Hỗ trợ phần mềm
            </button>
          </div>
        </div>
      </div>

      {loading && (
        <div className="text-center my-4">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      )}

      {!loading && (errorUser || errorProjectTasks || errorOtherTasks || errorYeuCauTasks || errorHoTroTasks) && (
        <div className="alert alert-danger">
          {errorUser && <div>- {String(errorUser)}</div>}
          {errorProjectTasks && <div>- {String(errorProjectTasks)}</div>}
          {errorOtherTasks && <div>- {String(errorOtherTasks)}</div>}
          {errorYeuCauTasks && <div>- {String(errorYeuCauTasks)}</div>}
          {errorHoTroTasks && <div>- {String(errorHoTroTasks)}</div>}
        </div>
      )}

      {!loading && !errorUser && !errorProjectTasks && !errorOtherTasks && !errorYeuCauTasks && !errorHoTroTasks && (
        <>
          {/* DEV */}
          {(filterTab === 'all' || filterTab === 'dev') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Công việc Phát triển phần mềm</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeProject}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeProject(newSize);
                            setPageProject(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={projectStatusFilter}
                          onChange={(e) => {
                            setProjectStatusFilter(e.target.value);
                            setPageProject(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_CONG_VIEC_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Mức độ:</label>
                        <select
                          className="form-control"
                          value={projectPriorityFilter}
                          onChange={(e) => {
                            setProjectPriorityFilter(e.target.value);
                            setPageProject(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_UU_TIEN.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setProjectStatusFilter('');
                            setProjectPriorityFilter('');
                            setPageProject(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: 70 }}>STT</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tên công việc</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Dự án</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Bước</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Mức độ</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tiến độ</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Bắt đầu</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Hạn chót</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedProjectTasks.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center text-muted">
                                Chưa có công việc dự án nào được giao cho bạn.
                              </td>
                            </tr>
                          )}

                          {pagedProjectTasks.map((item, index) => (
                            <tr key={item.assignmentId || item.congViecId || index}>
                              <td className="text-center">
                                {index + 1 + (pageProject - 1) * pageSizeProject}
                              </td>
                              <td className="font-weight-bold">
                                <span 
                                  className="text-primary" 
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    const urlString = createUrlWithParam(URI_INTERNAL.PROJECT_STEP_BOARD_PATH, { 
                                      projectId: item.projectId, 
                                      stepId: item.projectStepId, 
                                      taskId: item.congViecId 
                                    });
                                    const [pathPart, searchPart] = urlString.split('?');
                                    history.push({
                                      pathname: pathPart,
                                      search: searchPart ? `?${searchPart}` : '',
                                      state: { fromNhiemVuCaNhan: true }
                                    });
                                  }}
                                  title="Nhấn để xem và sửa công việc trong quy trình"
                                >
                                  {safeText(item.title)}
                                </span>
                              </td>
                              <td>{safeText(item.projectName)}</td>
                              <td>{safeText(item.projectStepName)}</td>
                              <td>{mapMucDoUuTienLabel(item.mucDo)}</td>
                              <td>
                                <span style={getStatusStyleProject(item.status)}>
                                  {mapTrangThaiCongViecLabel(item.status)}
                                </span>
                              </td>
                              <td className="text-center">
                                {(() => {
                                    const td = getEffectiveTienDoProjectTask(item);
                                    return td != null ? `${td}%` : '';
                                })()}
                              </td>

                              <td>{formatDate(item.ngayBatDau)}</td>
                              <td>{formatDate(item.hanChot)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageProject}
                        itemsCountPerPage={Number(pageSizeProject)}
                        totalItemsCount={totalProjectTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageProject(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* OTHER */}
          {(filterTab === 'all' || filterTab === 'other') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Nhiệm vụ khác</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeOther}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeOther(newSize);
                            setPageOther(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={otherStatusFilter}
                          onChange={(e) => {
                            setOtherStatusFilter(e.target.value);
                            setPageOther(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_KHAC_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Mức độ:</label>
                        <select
                          className="form-control"
                          value={otherPriorityFilter}
                          onChange={(e) => {
                            setOtherPriorityFilter(e.target.value);
                            setPageOther(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_UU_TIEN.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setOtherStatusFilter('');
                            setOtherPriorityFilter('');
                            setPageOther(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: 70 }}>STT</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Nhiệm vụ</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Công việc con</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Mức độ</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Tiến độ</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày giao</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Hạn chót</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người giao</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedOtherTasks.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center text-muted">
                                Chưa có nhiệm vụ khác nào được giao cho bạn.
                              </td>
                            </tr>
                          )}

                          {pagedOtherTasks.map((item, index) => (
                            <tr key={item.nhiemVuId || index}>
                              <td className="text-center">
                                {index + 1 + (pageOther - 1) * pageSizeOther}
                              </td>
                              <td>
                                <div 
                                  className="font-weight-bold text-primary" 
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => history.push(createUrlWithParam(URI_INTERNAL.NHIEMVUKHAC_EDIT_PATH, { id: item.nhiemVuId || item.id }))}
                                  title="Nhấn để sửa nhiệm vụ khác"
                                >
                                  {safeText(item.title)}
                                </div>
                              </td>
                              <td>
                                <div className="text-muted small">
                                  {item.tongSoCongViecCon > 0
                                    ? `${item.soCongViecConHoanThanh}/${item.tongSoCongViecCon}`
                                    : '0/0'}
                                </div>
                              </td>
                              <td>{mapMucDoUuTienLabel(item.mucDo)}</td>
                              <td>
                                <span style={getStatusStyleNhiemVuKhac(item.status)}>
                                  {mapTrangThaiKhacLabel(item.status)}
                                </span>
                              </td>
                              <td>{item.tienDo != null ? `${item.tienDo}%` : ''}</td>
                              <td>{formatDate(item.ngayGiao)}</td> 
                              <td>{formatDate(item.hanChot)}</td>
                              <td>{safeText(item.nguoiGiao)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageOther}
                        itemsCountPerPage={Number(pageSizeOther)}
                        totalItemsCount={totalOtherTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageOther(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* YEUCAU */}
          {(filterTab === 'all' || filterTab === 'yeucau') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Xử lý yêu cầu</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeYeuCau}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeYeuCau(newSize);
                            setPageYeuCau(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={yeuCauStatusFilter}
                          onChange={(e) => {
                            setYeuCauStatusFilter(e.target.value);
                            setPageYeuCau(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_YEU_CAU_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Ưu tiên:</label>
                        <select
                          className="form-control"
                          value={yeuCauPriorityFilter}
                          onChange={(e) => {
                            setYeuCauPriorityFilter(e.target.value);
                            setPageYeuCau(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_UU_TIEN.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setYeuCauStatusFilter('');
                            setYeuCauPriorityFilter('');
                            setPageYeuCau(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: 70 }}>STT</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Lĩnh vực</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Khoa</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày bắt đầu</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Dự kiến kết thúc</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ưu tiên</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Nội dung</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ticket</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người phối hợp</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ghi chú</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedYeuCauTasks.length === 0 && (
                            <tr>
                              <td colSpan={11} className="text-center text-muted">
                                Chưa có xử lý yêu cầu nào liên quan đến bạn.
                              </td>
                            </tr>
                          )}

                          {pagedYeuCauTasks.map((item, index) => (
                            <tr key={item.id || index}>
                              <td className="text-center">
                                {index + 1 + (pageYeuCau - 1) * pageSizeYeuCau}
                              </td>
                              <td>{getLinhVucNameById(item.linhVucId) || item.linhVucId}</td>
                              <td style={{ width: 110, whiteSpace: '' }}>
                                {getKhoaCodesByIds(item.khoaIds) || ''}
                              </td>

                              <td>{formatDate(item.ngayBatDau)}</td>
                              <td>{formatDate(item.ngayHoanThanhDuKien)}</td>
                              <td>{mapMucDoUuTienLabel(item.mucDo)}</td>
                                  <td style={{ minWidth: 220, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                    <span 
                                      className="text-primary" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => history.push(createUrlWithParam(URI_INTERNAL.YEUCAU_EDIT_PATH, { id: item.id }))}
                                      title="Nhấn để sửa yêu cầu"
                                    >
                                      {safeText(item.noiDung)}
                                    </span>
                                  </td>
                              <td className="text-center" style={{ width: 90, whiteSpace: '' }}>
                                {renderTicketLink(item.linkTicket)}
                              </td>

                              <td style={{ minWidth: 180 }}>
                                {getNguoiPhoiHopNamesByIds(item.nguoiPhoiHopIds) || '-'}
                              </td>

                              <td>
                                <span style={getStatusStyleYeuCau(item.status)}>
                                  {mapTrangThaiYeuCauLabel(item.status)}
                                </span>
                              </td>
                              <td style={{ minWidth: 200 }}>{safeText(item.ghiChu)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageYeuCau}
                        itemsCountPerPage={Number(pageSizeYeuCau)}
                        totalItemsCount={totalYeuCauTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageYeuCau(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* HOTRO */}
          {(filterTab === 'all' || filterTab === 'hotro') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Hỗ trợ phần mềm</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeHoTro}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeHoTro(newSize);
                            setPageHoTro(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={hoTroStatusFilter}
                          onChange={(e) => {
                            setHoTroStatusFilter(e.target.value);
                            setPageHoTro(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_HO_TRO_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Loại lỗi:</label>
                        <select
                          className="form-control mr-2"
                          value={hoTroLoaiLoiFilter}
                          onChange={(e) => {
                            setHoTroLoaiLoiFilter(e.target.value);
                            setPageHoTro(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {LOAI_LOI_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Mức độ:</label>
                        <select
                          className="form-control"
                          value={hoTroMucDoFilter}
                          onChange={(e) => {
                            setHoTroMucDoFilter(e.target.value);
                            setPageHoTro(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_PHUC_TAP_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setHoTroStatusFilter('');
                            setHoTroLoaiLoiFilter('');
                            setHoTroMucDoFilter('');
                            setPageHoTro(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: 70 }}>STT</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Lĩnh vực</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày hỗ trợ</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Nội dung</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Khoa</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Loại lỗi</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Mức độ</th>
                            <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ghi chú</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedHoTroTasks.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center text-muted">
                                Chưa có hỗ trợ phần mềm nào liên quan đến bạn.
                              </td>
                            </tr>
                          )}

                          {pagedHoTroTasks.map((item, index) => (
                            <tr key={`${item.linhVucId || ''}-${item.ngayHoTro || ''}-${index}`}>
                              <td className="text-center">
                                {index + 1 + (pageHoTro - 1) * pageSizeHoTro}
                              </td>
                              <td>{getLinhVucNameById(item.linhVucId) || item.linhVucId}</td>
                              <td>{formatDate(item.ngayHoTro)}</td>
                              <td style={{ minWidth: 240 }}>
                                <span 
                                  className="text-primary" 
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => history.push(createUrlWithParam(URI_INTERNAL.HOTRO_EDIT_PATH, { id: item.id }))}
                                  title="Nhấn để sửa hỗ trợ"
                                >
                                  {safeText(item.noiDung)}
                                </span>
                              </td>
                              <td>
                                <span style={getStatusStyleHoTro(item.status)}>
                                  {mapTrangThaiHoTroLabel(item.status)}
                                </span>
                              </td>
                              <td style={{ width: 110, whiteSpace: '' }}>
                                {getKhoaCodesByIds(item.khoaIds) || ''}
                              </td>

                              <td>{item.loaiLoi != null ? mapLoaiLoiLabel(item.loaiLoi) : ''}</td>
                              <td>{item.mucDoPhucTap != null ? mapMucDoPhucTapLabel(item.mucDoPhucTap) : ''}</td>
                              <td style={{ minWidth: 200 }}>{safeText(item.ghiChu)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageHoTro}
                        itemsCountPerPage={Number(pageSizeHoTro)}
                        totalItemsCount={totalHoTroTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageHoTro(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </>
      )}
    </div>
  );
};

export default NhiemVuCaNhan;
